import React from "react";
import { AuthTwoFAStepComponent } from "features/settings/Security/TwoFA/types";
import Text from "common/Typography/Text";
import { displayResultMessage } from "utils/misc";
import { useHistory, useRouteMatch } from "react-router-dom";
import {
  CONFIGURATION_DISABLE_TWO_FA_PATH,
  SECURITY_SETTINGS_PATH,
} from "common/constants";
import { useSelector } from "react-redux";
import VerificationCode from "features/auth/VerificationCode";
import Flex from "common/Boxes/Flex";
import { sharedLib } from "@shared/services/shared.service";
import useTypedTranslation from "@shared/common/i18n/useTypedTranslation";
import { LanguageNameSpaces } from "@shared/types";

export const StepThree: AuthTwoFAStepComponent = ({
  onUpdateStepStatus,
  index,
}) => {
  const { t } = useTypedTranslation(LanguageNameSpaces.SETTINGS);
  const isDisableTwoFAMode = useRouteMatch(CONFIGURATION_DISABLE_TWO_FA_PATH);
  const refreshToken = useSelector(
    sharedLib.selectors.authentication.selectRefreshToken
  );
  const [storeTwoFA, { isLoading: isLoadingStoreTwoFA }] =
    sharedLib.sharedApi.authentication.useStoreTwoFAMutation();
  const [disableTwoFA, { isLoading: isLoadingDisableTwoFA }] =
    sharedLib.sharedApi.authentication.useDisableTwoFAMutation();
  const isLoading = isLoadingStoreTwoFA || isLoadingDisableTwoFA;
  const history = useHistory();

  const getSuccessMessage = () =>
    !isDisableTwoFAMode
      ? t("two_fa.success_enabled")
      : t("two_fa.success_disabled");

  const getDefaultError = () =>
    !isDisableTwoFAMode ? t("two_fa.error_enable") : t("two_fa.error_disable");

  const onFinish = (code: string) => {
    const args = { two_factor_token: code };
    const promise = isDisableTwoFAMode
      ? disableTwoFA(args)
      : storeTwoFA({
          ...args,
          refresh_token: refreshToken,
        });
    displayResultMessage(
      promise,
      getSuccessMessage(),
      getDefaultError(),
      5,
      async () => {
        const response = await promise;
        if ("data" in response && response.data?.code === 200) {
          onUpdateStepStatus("finish", index);
          history.replace(SECURITY_SETTINGS_PATH);
        } else {
          onUpdateStepStatus("error", index);
        }
      }
    );
  };

  return (
    <Flex $flexDirection="column">
      <Text>{t("two_fa.step_three_instruction")}</Text>
      <VerificationCode
        numOfDigits={NUM_OF_DIGITS_CODE}
        onSubmit={onFinish}
        isLoading={isLoading}
        buttonText={
          !isDisableTwoFAMode
            ? t("two_fa.enable_button")
            : t("two_fa.disable_button")
        }
      />
    </Flex>
  );
};

const NUM_OF_DIGITS_CODE = 6;
